<template>
  <div class="wrapper">
    <page-header/>
    <div class="content contract-content p-0">
      <error-banner v-if="error" :message="error"/>
      <template v-else>
        <template v-if="contract">
          <download-link v-if="isSigned" :contract="contract"/>
          <template v-else>
            <pdf-viewer :contract="contract"/>
            <signing-form v-if="signatureRequired" :contract="contract" @signed="tryCompleteContract"/>
          </template>
        </template>
        <template v-else>
          <page-loader v-if="loading"/>
        </template>
      </template>
    </div>
    <page-footer v-if="isSigned || !signatureRequired"/>
  </div>
</template>

<script>
import { WebApi } from '@/services/WebApi'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import PageLoader from '../Loading/PageLoader.vue'
import DownloadLink from './DownloadLink.vue'
import PdfViewer from './PdfViewer.vue'
import SigningForm from './SigningForm.vue'
import ErrorBanner from '../ErrorValidation/ErrorBanner.vue'
import PageHeader from '../Layout/PageHeader.vue'
import PageFooter from '../Layout/PageFooter.vue'

export default {
  name: 'ContractPage',
  data () {
    return {
      error: '',
      loading: false,
      contract: null
    }
  },
  computed: {
    contractId () {
      return this.$route.query.id
    },
    isSigned () {
      return !!this.contract && this.contract.status.id === 5
    },
    signatureRequired () {
      return !!this.contract && this.contract.signatureRequired
    }
  },
  methods: {
    tryFetchContract () {
      const self = this
      if (!self.contractId) {
        return
      }
      self.error = ''
      self.loading = true
      WebApi.get('ClientContract/' + self.contractId)
        .then(response => { self.contract = response.data })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    },
    tryCompleteContract () {
      const self = this
      if (!self.contractId) {
        return
      }
      self.error = ''
      self.loading = true
      WebApi.put('ClientContract/' + self.contractId + '/Complete')
        .then(response => { self.contract = response.data })
        .catch(error => { self.error = ErrorHelper.getError(error) })
        .finally(() => { self.loading = false })
    }
  },
  created () {
    this.tryFetchContract()
  },
  components: {
    'page-loader': PageLoader,
    'error-banner': ErrorBanner,
    'page-header': PageHeader,
    'page-footer': PageFooter,
    'download-link': DownloadLink,
    'pdf-viewer': PdfViewer,
    'signing-form': SigningForm
  }
}
</script>

<style scoped>
.wrapper {
  height: 100vh;
}

.contract-content {
  padding-block: 0;
  width: 100%;
  max-width: 100%;
  min-height: 0;
}
</style>
